module.exports = __webpack_public_path__ + "img/confluence.81cd16e4.png";